import { base } from '@service/base';

export async function removeUpsellStepFlow(upsellStepIds: number[]) {
  await base.delete(`/funnel/flow-steps`, {
    data: upsellStepIds,
  });
}
